export default {
  云招商: 'merchants',
  最近成功找到加盟商: 'Recently successfully found a franchisee',
  火热招商中: 'Hot Merchants',
  招商中: 'Inviting investment',
  招商名称: 'Merchant Name',
  更多云招商推荐: 'More Cloud Merchants Recommendations',
  招商品牌: 'Merchants brand',
  招商类型: 'Merchants Type',
  已加盟数: 'Has joined the number',
  招商流程: 'Merchants process',
  最低投资金额: 'Minimum investment amount',
  服务支持: 'service support',
  招商对象: 'Investment object',
  招商地区: 'Investment area',
  '全国(中国)': 'National (China)',
  我要加盟: 'I want to join',
  招商详细介绍: 'introduction',
  招商支持: 'Investment support',
  招商视频: 'video',
  招商图片: 'photo',
  招商品牌logo: 'brand logo',
  招商编号: 'merchant no.',
  最近发布时间: 'Last release time',
  加盟人数: 'Number of franchisees',
}
